import * as Vue from "vue";
import * as VueRouter from "vue-router";
import VueCryptojs from "vue-cryptojs";
import vuetify from "./plugins/vuetify";
import veevalidate from "./plugins/veevalidate";
import Vue3Toastify, { toast } from "vue3-toastify";
import VueGoogleMaps from "@fawmi/vue-google-maps";

import { authService } from "@/libs/ws/authService";
import routes from "./routes";
import store from "./store";

//Components Globales
import App from "./App.vue";
import FontAwesomeIcon from "./plugins/fontawesome";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import DialogInfo from "@/components/DialogInfo.vue";
//Stepper va ser reemplazado por vuetify cuando incorpore el stepper
import { Steps } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

require("@/assets/css/style.scss");
import "vue3-toastify/dist/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import '@mdi/font/css/materialdesignicons.css' // Iconos

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authService.isAuthenticated()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    if (authService.isAuthenticated() && to.path == "/login") {
      next({
        path: "/",
      });
    } else {
      next(); // make sure to always call next()!
    }
  }
});

const app = Vue.createApp(App);

app.config.globalProperties.toast = toast;

app.use(router);
app.use(vuetify);
app.use(veevalidate);
app.use(store);
app.use(VueCryptojs);
app.use(Vue3Toastify, {
  position: toast.POSITION.BOTTOM_RIGHT,
  theme: "dark",
});
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBZxqX4N1D48xhiYscozVya07W9haBj0ro",
  },
});
app.use(Steps);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("Title", Title);
app.component("DialogDelete", DialogDelete);
app.component("DialogLoading", DialogLoading);
app.component("DialogYesNo", DialogYesNo);
app.component("DialogInfo", DialogInfo);
app.mount("#app");